import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "14",
  fill: "currentColor",
  viewBox: "0 0 18 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M9 11.784a7.97 7.97 0 0 1-7.453-5.141 7.972 7.972 0 0 1 14.906 0A7.97 7.97 0 0 1 9 11.784M9 .001A9.47 9.47 0 0 0 .04 6.4a.75.75 0 0 0 0 .486 9.473 9.473 0 0 0 17.92 0 .75.75 0 0 0 0-.486A9.47 9.47 0 0 0 9 0m-.01 4.412a2.23 2.23 0 0 0 0 4.46h.017a2.23 2.23 0 0 0 0-4.46z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }